import { IApplicationState } from '@spinwise/spinwise-core';
import { usePrevious } from 'Hooks/usePrevious';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { logoutChannel } from 'src/channels/logout.channel';

const LogoutListener = ({ forcedLocale }: { forcedLocale: string }) => {
  const dispatch = useDispatch();
  const router = useRouter();

  const auth = useSelector((state: IApplicationState) => state.authReducer.auth);
  const geo = useSelector((state: IApplicationState) => state.globalReducer.geo);
  const currentLanguage = useSelector((state: IApplicationState) => state.globalReducer.currentLanguage);
  const languages = useSelector((state: IApplicationState) => state.globalReducer.languages?.data);

  const prevLanguage = usePrevious<typeof currentLanguage>(currentLanguage);
  const prevGeo = usePrevious<typeof geo>(geo);
  const prevLanguages = usePrevious<typeof languages>(languages);
  const prevForcedLocale = usePrevious<typeof forcedLocale>(forcedLocale);

  const { i18n: i18n2 } = useTranslation();

  useEffect(() => {
    if (prevForcedLocale !== forcedLocale) {
      i18n2.changeLanguage(forcedLocale);
    }

    if (prevLanguage && prevLanguage?.code && prevLanguage?.code !== currentLanguage?.code) {
      i18n2.changeLanguage(currentLanguage?.code);
    }

    if (geo?.deny !== prevGeo?.deny && geo?.deny && typeof prevGeo?.deny !== 'undefined') {
      window.location.reload();
    }

    // received update
    if (languages?.length > 0 && prevLanguages?.length === 0) {
      // unless defualt cookie exists?
      let { locale } = router;
      let main = locale;
      let exists = false;

      // goal: check if locale is not in list
      languages?.forEach((lang: any) => {
        if (lang.main) {
          main = lang.code;
        }

        if (lang.code === locale) {
          exists = true;
        }
      });

      if (exists === false) {
        const { pathname, query, asPath } = router;

        i18n2.changeLanguage(main);
        router.push({ pathname, query }, asPath, { locale: main });
      }
    }

    // @ts-ignore
    if (auth?.success === false && auth?.code === 401) {
      dispatch({
        type: 'CLEAR_CACHE',
        data: true,
      });
      logoutChannel.send({ action: 'logout_start', loaded: true });
    }
    // @ts-ignore
  }, [currentLanguage?.code, geo?.deny, languages, auth.success, auth.code]);

  return null;
};

export default LogoutListener;
